export const TABS = {
  LOADING_SCREEN: 1,
  SIGNUP_LOGIN: 2,
}

export const LOADING_SCREEN_TABS = {
  BACKGROUND: 1,
  LOGO: 2,
}

export const SIGNUP_LOGIN_TABS = {
  BACKGROUND: 1,
  LOGO: 2,
  BOTTOM_LOGO: 3,
  TEXT: 4,
  BUTTONS: 5,
}

export const DEFAULT_TAB = TABS.LOADING_SCREEN
export const FIRST_TAB = TABS.LOADING_SCREEN
export const LAST_TAB = TABS.SIGNUP_LOGIN

export const WIDTH_TYPES = {
  PIXEL: "PIXEL",
  PERCENTAGE: "PERCENTAGE",
  FULL_WIDTH: "FULL_WIDTH",
}

export const FONT_TYPES = {
  PREDEFINED: "PREDEFINED",
  FILE: "FILE",
}

export const DEFAULT_FONT = "Arial"

export const ACCEPTED_FONT_TYPES =
  ".JFPROJ,.WOFF,.PFA,.FNT,.TTF,.FOT,.SFD,.VLW,.OTF,.GXF,.WOFF2,.PFB,.ODTTF,.ETX,.FON,.CHR,.VFB,.ABF,.BDF,.TTC,.GF,.PFM,.PMT,.AMFM,.COMPOSITEFONT,.MF,.GDR,.VNF,.MXF,.PCF,.TFM,.BF,.SFP,.GLIF,.PFR,.XFN,.AFM,.DFONT,.ACFM,.EOT,.TTE,.XFT,.FFIL,.PK,.SUIT,.PF2,.NFTR,.TXF,.EUF,.LWFN,.CHA,.MCF,.T65,.UFO,.YTF,.F3F,.FEA"
